<template>
  <div class="tooltip padding-vertical-ml padding-horizontal-m margin-bottom-ml"
       :style="{ 'background-image': `url(${bodyImagePath})` }">
    <div class="flex-row space-between">
      <div class="flex-row align-center margin-bottom-xs">
        <img v-if="imagePath" :src="imagePath" class="margin-left-xs" />
        <div class="ri-bold-body">{{title}}</div>
      </div>
      <icon v-if="allowDismiss" class="dismiss-btn" icon-name="cancel" size="24px" fill
             @click="handleDismiss" @keyup.enter="handleDismiss" tabindex="0" role="button" :color="dismissIconColor"/>
    </div>
    <div class="margin-bottom-m">
      <slot></slot>
    </div>
    <card-action-button :text="ctaText"
                        :background-color="backgroundColor"
                        :border-color="borderColor"
                        @click="handleActionButtonClick"/>
  </div>
</template>

<script>
import CardActionButton from '@/base-components/card-parts/CardActionButton';
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'CtaTooltip',
  components: {
    CardActionButton,
    Icon: BaseUI.Icon,
  },
  data() {
    return {
      dismissIconColor: BaseUI.Colors.riseupGray60,
      backgroundColor: BaseUI.Colors.riseupLightBlue,
      borderColor: BaseUI.Colors.riseupGray1,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    ctaText: {
      type: String,
      required: true,
    },
    imagePath: {
      type: String,
      required: false,
    },
    bodyImagePath: {
      type: String,
      required: false,
    },
    allowDismiss: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    handleDismiss() {
      this.$emit('dismiss');
    },
    handleActionButtonClick() {
      this.$emit('click');
    },
  },

};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import "~@riseupil/base-ui/src/scss/box-shadow";
@import '~@riseupil/base-ui/src/scss/spacings';
@import '~@riseupil/base-ui/src/scss/border-radius';

.tooltip {
  background: $riseup_light_blue no-repeat bottom left;
  border: 1px solid $riseup_gray_0;
  border-radius: $ri-border-radius-medium;
  box-shadow: $ri-medium-box-shadow;

  .dismiss-btn {
    margin-top: -$ri-spacing-xxs;
    margin-left: -$ri-spacing-xs;
    cursor: pointer;
  }
}
</style>
